import { render } from "./PayModalSectionAmounts.vue?vue&type=template&id=44e237eb"
import script from "./PayModalSectionAmounts.vue?vue&type=script&lang=js"
export * from "./PayModalSectionAmounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__